<template>
    <v-container fluid class="grey lighten-5 pa-0">
        <v-row no-gutters>
            <v-navigation-drawer
                v-model="filterDrawer"
                :temporary="isMobilePort"
                :mobile-breakpoint="600"
                app
                clipped
                :width="isMobilePort ? '100%' : 360"
            >
                <filters
                    :filters="filters"
                    :userProfileType="userProfileType"
                    @close="filterDrawer = false"
                    @apply-filters="applyFilters"
                    :default-filters="activeFilters"
                    :apply-instant-filters="!isMobilePort"
                />
            </v-navigation-drawer>

            <!-- Main Content -->
            <div style="width: 100%">
                <!-- Top Bar -->
                <v-card flat class="outlined-except-top-left">
                    <v-container fluid class="content-container" :class="!isMobilePort ? 'px-6' : ''">
                        <v-row align="center">
                            <v-col cols="12" md="8">
                                <h2 class="text-h4 font-weight-medium">Notes and Bookmarks</h2>
                                <share-feedback/>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                                class="d-flex"
                                :class="{
                                    'd-flex justify-end': !isMobilePort
                                }"
                            >

                                <v-menu offset-y>

                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                outlined
                                                class="mr-2"
                                                v-bind="attrs"
                                                v-on="on">
                                            Actions
                                            <v-icon class="ml-1">mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item :href="getRoute('dashboard_my_tags')">
                                            <v-list-item-icon class="mr-3">
                                                <v-icon>mdi-label-outline</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>Manage Tags</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <a
                                        class="v-btn primary v-btn--flat v-btn--outlined theme--dark v-size--default"
                                        :href="getNotesPrintUrl()"
                                        target="_blank"
                                        @click="onPrintClick"
                                >
                                    Print ({{ pagination.total }} sections)
                                </a>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <v-container v-show="!isLoading" fluid class="content-container container-height" :class="!isMobilePort ? 'px-5' : ''">
                    <v-overlay :value="isLoading" absolute>
                        <v-progress-circular indeterminate size="64"/>
                    </v-overlay>
                    <v-row align="center" justify="space-between">
                        <v-col :cols="isMobilePort ? 12 : 6">
                            <div class="d-flex align-center justify-space-between w-100">
                                <div class="d-flex align-center">
                                    <h3 class="mb-0 font-weight-medium">
                                        <span>Showing {{ contentSections.length }} of {{ pagination.total }} sections</span>
                                    </h3>
                                    <span class="ml-2 text--secondary">({{ getTotalNotesBookmarks }} notes)</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col
                           :cols="isMobilePort ? 12 : 6"
                            :class="{
                                'd-flex justify-end': !isMobilePort
                            }"
                        >
                            <v-btn
                                v-if="isMobilePort"
                                block
                                class="mb-5"
                                outlined
                                @click="filterDrawer = true">
                                <v-icon left>mdi-filter-variant</v-icon>
                                    Filters
                            </v-btn>
                            <v-select
                                v-model="selectedSort"
                                :items="sortOptions"
                                item-text="text"
                                item-value="value"
                                label="Sort by"
                                :block="isMobilePort"
                                :class="isMobilePort ? 'mb-5' : ''"
                                dense
                                hide-details
                                outlined
                                :style="{ maxWidth: isMobilePort ? '100%' : '250px' }"
                                :menu-props="{ bottom: true, offsetY: true }"
                                @change="triggerSortingChange"
                                />
                        </v-col>
                    </v-row>
                    <!-- Active filter chips -->
                    <active-filter-chips
                        :is-loading="isLoading"
                        class="mb-6"
                        :filters="filters"
                        :active-filters="activeFilters"
                        @clear-group="clearGroupFilter"
                        @remove-single-filter="removeSingleFilter" />
                    <!-- Content Sections -->
                    <default-content-section-controller
                        v-show="contentSections.length"
                        @sectionSortOrderChanged="sectionSortOrderChanged"
                        highlightType="add-note"
                        :content-sections="contentSections"
                        :is-notes-section-expanded="true"
                    />

                    <v-row v-if="!isLoading && !contentSections.length" justify="center">
                        <v-col class="text-center" cols="12" sm="4">
                            <v-icon large color="primaryMedium">mdi-bookmark-multiple-outline</v-icon>
                            <h3 class="text-h6 font-weight-medium mt-2">No notes or bookmarks found here</h3>
                            <div class="text-body-1 text--secondary mt-2">
                                Try clearing your filters. Or try bookmarking sections and adding notes to get started.
                            </div>
                            <v-btn
                                outlined
                                color="primary"
                                href="https://support.iccsafe.org/ht_kb/digital-codes/how-to-create-notes/"
                                target="_blank"
                                class="mt-2"
                            >Learn About Notes</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container
                    v-if="isLoading"
                    fluid
                    class="content-container container-height"
                >
                    <loading>
                        <span class="text-h6 font-weight-medium">Loading your notes...</span>
                    </loading>
                </v-container>
                <v-container
                    v-if="contentSections.length < pagination.total"
                    fluid
                    class="content-container"
                >
                    <div style="width: 100%" class="text-center">
                        <v-btn
                            :loading="isMoreLoading"
                            color="primary"
                            @click="loadMore"
                        >
                            Show next {{ showNext }}
                        </v-btn>
                    </div>
                </v-container>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import {mapGetters, mapActions } from 'vuex';

import Filters from "./filters.vue";
import ShareFeedback from "../../links/ShareFeedback.vue";
import Mobile from '../../inc/mixins/mobile';
import {ContentSectionApi} from "../../../api/ContentSectionApi";
import DefaultContentSectionController from "../../content-section/DefaultContentSectionController.vue";
import ActiveFilterChips from "./ActiveFilterChips.vue";
import {NotesPageApi} from "../../../api/NotesPageApi";
import { defaultFilters } from "./defaultFilters";
import Loading from "../../content/partials/loading.vue";

export default {
    components: {DefaultContentSectionController, ShareFeedback, Filters, ActiveFilterChips, Loading},
    mixins: [Mobile],
    data() {
        return {
            filterDrawer: true,
            isLoading: false,
            isMoreLoading: false,
            showFilters: false,
            contentSections: [],
            activeFilters: defaultFilters(),
            filters: {},
            pagination: {total: 0, offset: 0, limit: 20},
            sort: [{ field: this.$getConst('notes').sortDateField, direction: 'DESC' }],
            userProfileType: '',
            selectedSort: 'newest',
            sortOptions: [
                { text: 'Newest Activity First', value: 'newest' },
                { text: 'Oldest Activity First', value: 'oldest' },
                { text: 'Section Number (Ascending)', value: 'section' }
            ]
        };
    },
    computed: {
        ...mapGetters('NotesBookmarksModule', [
            'getTotalNotesBookmarks'
        ]),
        showNext() {
            const remaining = this.pagination.total - this.contentSections.length;
            return remaining > this.pagination.limit
                ? this.pagination.limit
                : remaining;
        },
        selectedNotes() {

            const notes = [];

            for (const section of (this.contentSections || [])) {

                (section.bookmarks || []).forEach((value) => {

                    if ('annotation' in value) {
                        notes.push('annotation_' + value.id)
                    } else {
                        notes.push('bookmark_' + value.id);
                    }
                });
            }

            return notes;
        }
    },
    watch: {
        isMobilePort(val) {
            // Optionally close drawer when switching to mobile
            if (val) {
                this.filterDrawer = false;
            }
        },
        activeFilters: {
            deep: true,
            handler() {
                this.resetPagination();
                this.updateAndGetContentSections();
            }
        }
    },
    mounted() {
        this.getPageInfo();
        this.getContentSections();
    },
    methods: {
        ...mapActions('NotesBookmarksModule', [
            'updateTotalNotesBookmarks'
        ]),
        sectionSortOrderChanged(event) {
            let existent = localStorage.getItem('section_notes_sort_order_change');
            if (existent) {
                existent = JSON.parse(existent);
            } else {
                existent = {};
            }
            existent[event.sectionId] = event.sortOrder;
            localStorage.setItem('section_notes_sort_order_change', JSON.stringify(existent));
        },
        onPrintClick() {
            localStorage.setItem('print_preview_query_params', JSON.stringify(this.getQueryParams()));
        },
        async getPageInfo() {
            try {
                const response = await NotesPageApi.getPageInfo();
                if (response.filterOptions) {
                    this.filters = response.filterOptions;
                    this.userProfileType = response.userProfileType;
                }
            } catch (err) {
               //TODO:: do something?
            }
        },
        triggerSortingChange() {
            this.getContentSections(false, true);
        },
        async getContentSections(isLoadMore = false, sortChange = false) {
            if (isLoadMore) {
                this.isMoreLoading = true;
            } else {
                this.isLoading = true;
            }

            if('newest' === this.selectedSort) {
                this.sort = [{ field: this.$getConst('notes').sortDateField, direction: 'DESC' }];
            } else if('oldest' === this.selectedSort) {
                this.sort = [{ field: this.$getConst('notes').sortDateField, direction: 'ASC' }];
            } else {
                this.sort = [{ field: 'section_title', direction: 'ASC' }];
            }

            try {
                const queryParams = this.getQueryParams(sortChange);
                const response = await ContentSectionApi.queryByUserNotes(queryParams);
                const {items, ...pagination} = response.pagination;

                this.pagination = pagination;
                this.updateTotalNotesBookmarks(response.totalNotes);

                if (isLoadMore) {
                    this.contentSections.push(...items);
                    this.isMoreLoading = false;
                } else {
                    this.contentSections = [...items];
                }

                this.isLoading = false;
            } catch (err) {
                if (!axios.isCancel(err)) { //except cancelled request
                    this.isMoreLoading = false;
                    this.isLoading = false;
                }
            }
        },
        removeSingleFilter({ key, value }) {
            const current = this.activeFilters[key];
            if (Array.isArray(current)) {
                this.activeFilters[key] = current.filter(v => v !== value);
            } else {
                this.activeFilters[key] = null;
            }
        },
        loadMore() {
            if (this.contentSections.length < this.pagination.total) {
                this.pagination.offset = this.pagination.offset + this.pagination.limit;
                this.getContentSections(true);
            }
        },
        clearGroupFilter(key) {
            this.activeFilters[key] = Array.isArray(this.activeFilters[key]) ? [] : null
        },
        applyFilters(filters) {
            this.activeFilters = filters;
        },
        buildQueryParams(filters) {
            const queryParams = {};
            for (const key in filters) {
                const value = filters[key];
                if (Array.isArray(value) && value.length > 0) {
                    queryParams[key] = value;
                } else if (value !== null && value !== '' && value !== undefined) {
                    queryParams[key] = value;
                }
            }

            return queryParams;
        },
        resetPagination() {
            this.pagination = {total: 0, offset: 0, limit: 20};
        },
        getQueryParams(sortChange = false) {
            return {
                ...this.buildQueryParams(this.activeFilters),
                offset: sortChange ? 0 : this.pagination.offset,
                limit: sortChange ? 20 : this.pagination.limit,
                sort: this.sort,
            };
        },
        getNotesPrintUrl() {
            return Routing.generate('notes_print_preview')
        }
    },
    created() {
        localStorage.setItem('section_notes_sort_order_change', JSON.stringify({}));
        this.updateAndGetContentSections = _.debounce(this.getContentSections, 1000);

        //hide filter drawer initially for mobile view
        if (this.isMobilePort) {
            this.filterDrawer = false;
        }
    }
};
</script>

<style scoped>
.outlined-except-top-left {
    border: 1px solid #E0E0E0;
    border-top: none;
    border-left: none;
}
</style>
